import React, { useState } from 'react';
import { getPendingPromoMeta, type PendingPromoMeta } from '../utils/rebookPromo';

type Props = {
  /** Om satt: använd denna meta; annars läs från sessionStorage. */
  meta?: PendingPromoMeta | null;
  className?: string;
  dismissible?: boolean;
};

/**
 * Synlig banner när en rabattkod är sparad — förklarar att ordinarie pris
 * visas och att rabatten appliceras automatiskt i sista steget i kassan.
 */
const PendingPromoBanner: React.FC<Props> = ({
  meta: metaProp,
  className = '',
  dismissible = true,
}) => {
  const [hidden, setHidden] = useState(false);
  const meta = metaProp === undefined ? getPendingPromoMeta() : metaProp;

  if (hidden || !meta) return null;

  return (
    <div
      className={`rounded-xl border border-emerald-500/35 bg-gradient-to-r from-emerald-950/50 to-slate-900/40 px-4 py-3 sm:px-5 sm:py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 ${className}`}
    >
      <p className="text-sm text-emerald-50/95 leading-relaxed">
        <span className="font-semibold text-emerald-200">{meta.label}:</span> {meta.bannerMessage}
      </p>
      {dismissible && (
        <button
          type="button"
          onClick={() => setHidden(true)}
          className="self-start sm:self-auto text-xs text-slate-400 hover:text-slate-200 underline-offset-2 hover:underline shrink-0"
        >
          Dölj
        </button>
      )}
    </div>
  );
};

export default PendingPromoBanner;
